import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoLabelWrap]',
  host: { class: 'xpo-Label--wrap' },
})
export class XpoLabelWrap {}
